module.exports = __webpack_public_path__ + "img/menu-point.02ca8b96.svg";